import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useCallback, useState } from 'react';
import { tailwindConfig } from 'tailwind-config';

import { ProjectModal } from 'modals';
import { useTypedSelector } from 'store';

import { CreateIcon } from 'assets/icons';

interface CreateNewProjectProps {
  forceExpandedLayout?: boolean;
  defaultNotes?: string;
  stayOnPage?: boolean;
}

const CreateNewProject: React.FC<CreateNewProjectProps> = ({
  forceExpandedLayout = false,
  defaultNotes,
  stayOnPage = false,
}) => {
  const isSidebarOpened = useTypedSelector(store => store.ui.isSidebarOpened);
  const isExpandedLayout = forceExpandedLayout || isSidebarOpened;
  const [isActive, setIsActive] = useState<boolean>(false);

  const onClickCreateNewProject = useCallback((): void => {
    setIsActive(v => !v);
  }, []);

  const onCloseCreateNewProject = useCallback((): void => {
    setIsActive(false);
  }, []);

  const onReopenCreateNewProject = useCallback((): void => {
    setIsActive(true);
  }, []);

  return (
    <>
      <div
        className={cn('mm-sidebar__menu__item', { _active: isActive })}
        onClick={onClickCreateNewProject}
      >
        <div className="mm-sidebar__menu__item__left">
          <div className="mm-sidebar__menu__item__icon">
            <CreateIcon color={isActive ? tailwindConfig.theme.colors.primary : undefined} />
          </div>
          <AnimatePresence>
            {isExpandedLayout && (
              <motion.span
                exit={{ opacity: 0, width: 0 }}
                transition={{ duration: isExpandedLayout ? 0.25 : 0.2 }}
                className="mm-sidebar__menu__item__text align-left"
              >
                Create new project
              </motion.span>
            )}
          </AnimatePresence>
        </div>
      </div>
      {isActive && (
        <ProjectModal
          type="create"
          onClose={onCloseCreateNewProject}
          onOpen={onReopenCreateNewProject}
          initialTitle={undefined}
          initialNotes={defaultNotes}
          initialUsers={[]}
          stayOnPage={stayOnPage}
        />
      )}
    </>
  );
};

export { CreateNewProject };
